<template>
  <div class="ui-content dashboard">
    <div class="center-box" ref="centerBox">
      <div class="create-batch-bt-blk">
        <div class="batch-align-mobile" v-if="centers && centers.length > 0">
          <span v-for="(center, index) in centers" :key="center.id">
            <v-tooltip top content-class="cust-new-tooltip-top">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="onCenterClick(center)"
                  depressed
                  :class="{
                    'text-transform-none': true,
                    'btn-center': true,
                    'btn-default': true,
                    active: center.id === selectedCenter.id,
                  }"
                  >{{ center.name }}</v-btn
                >
              </template>
              <span>{{ center.name }}</span>
            </v-tooltip>

            <v-tooltip
              top
              content-class="cust-new-tooltip-top"
              v-if="canAddCenters()"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="index === centers.length - 1"
                  class="rounded-btn-add"
                  v-on="on"
                  color="primary"
                  @click="AddCenterDialog()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Add Center</span>
            </v-tooltip>
          </span>
        </div>
        <div v-else-if="canAddCenters()">
          <v-tooltip top content-class="cust-new-tooltip-top">
            <template v-slot:activator="{ on }">
              <v-btn
                class="rounded-btn-add"
                v-on="on"
                color="primary"
                @click="AddCenterDialog()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Center</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <v-card class="mx-auto normal-card min-height-80vh-cp3-card">
      <div
        class="data-table-section create-batch"
        :style="{ height: tableHeight }"
      >
        <v-data-table
          :headers="headers"
          fixed-header
          :items="batches"
          :items-per-page="pageSize"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="text-center width-300-mx">
                  <v-tooltip top content-class="cust-new-tooltip-top">
                    <template v-slot:activator="{ on }">
                      <div class="max-char" v-on="on">{{ item.name }}</div>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                </td>
                <td>{{ item.datatype_name }}</td>
                <td class="text-center max-220-width">
                  <v-tooltip top content-class="cust-new-tooltip-top">
                    <template v-slot:activator="{ on }">
                      <div class="ellipsis-txt" v-on="on">
                        {{ item.subjects }}
                      </div>
                    </template>
                    <span>{{ item.subjects }}</span>
                  </v-tooltip>
                </td>
                <td class="text-center">{{ item.total_student }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <div
          class="add-batch-btn add-batch-btn-position"
          v-if="canAddBatches()"
        >
          <v-tooltip top right content-class="cust-new-tooltip-top">
            <template v-slot:activator="{ on }">
              <v-btn
                @click="AddBatchDialog()"
                :disabled="centers && centers.length == 0"
                class="rounded-btn-add disabled"
                v-on="on"
                color="primary"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add Batch</span>
          </v-tooltip>
          <!-- <span class="batch-title">Batch</span> -->
        </div>
      </div>
    </v-card>
    <div class="footer-btn">
      <div></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import isMobile from "is-mobile";
import constants from "@/utils/constants.js";

export default {
  name: "CreateBatch",
  beforeDestroy() {
    // window.removeEventListener("resize", this.getBatchesByCenterId);
    window.onresize = null;
  },
  mounted() {
    this.requestGetCenters();
    this.initFunction();
  },
  data() {
    return {
      alertBoxData: {},
      tableHeight: "350px",
      batches: [],
      centers: [],
      classes: [],
      selectedCenter: null,
      selectedBatch: null,
      status: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      orderByForCenter: {
        field: "name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      modalwidth: null,
      cComponent: "components/coordinator/AddBatch",
      headers: [
        {
          text: "Batch Name",
          value: "name",
          class: "text-center width-300-mx",
        },
        { text: "Category", value: "category", hideSort: true },
        {
          text: "Subjects",
          value: "subjects",
          hideSort: true,
          class: "text-center",
        },
        {
          text: "No. Of Students",
          value: "nostudents",
          hideSort: true,
          class: "text-center",
        },
      ],
      items: [],
      isMobileDevice: isMobile(),
    };
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
    }),
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      this.selectedCenter = this.centers[0];
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        let selectedCenter = this.centers.find((c) => c.id == crd.selectedTab);
        if (selectedCenter) this.selectedCenter = selectedCenter;
      }
      this.$nextTick(() => {
        this.getBatchesByCenterId();
      });
    },
    canAddCenters() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return user && user.role_id === constants.ROLES_ID.ID;
    },
    canAddBatches() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      return (
        user &&
        (user.role_id === constants.ROLES_ID.ID ||
          user.role_id === constants.ROLES_ID.CO)
      );
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let selectedTab =
          crd && crd.selectedTab ? crd.selectedTab : this.centers[0].id;
        let subTabDetails = {
          page: 1,
          orderBy: {
            field: "name",
            order: "ASC",
          },
        };

        let tabDetail = {};
        this.centers.map((c) => {
          tabDetail[c.id] = subTabDetails;
        });
        let routeDetails = {
          routeName: rp.name,
          selectedTab: selectedTab,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    initFunction() {
      this.isMobileDevice = this.checkIfMobile();
      window.addEventListener(
        "resize",
        _.debounce(this.getBatchesByCenterId, 500)
      );
    },
    checkIfMobile() {
      return isMobile();
    },
    async setCustomData() {
      if (this.$refs.centerBox) {
        let centerBoxHeight = this.$refs.centerBox.clientHeight;
        let height = window.innerHeight;
        height = height - 220 - centerBoxHeight;
        this.tableHeight = height + "px";
        let pageSize = height / 48;
        pageSize = parseInt(pageSize);
        // this.pageSize = pageSize - 2;

        if (this.isMobileDevice) {
          this.pageSize = pageSize - 1;
        } else {
          this.pageSize = pageSize - 2;
        }
        return true;
      }
    },
    onCenterClick(center) {
      this.selectedCenter = center;
      this.currentPage = 1;
      this.orderBy = {
        field: "name",
        order: "ASC",
      };
      let routeName = this.$route.name;
      this.setRouteDetails({ routeName, selectedTab: center.id });
      this.onPageChange(this.currentPage);
      // this.requestGetBatch(center.id);
    },
    onClose(data) {
      this.status = data.status;
      if (data.reloadBatches) {
        this.requestGetBatch(this.selectedCenter.id);
      } else if (data.reload) {
        this.requestGetCenters();
      }
    },
    AddCenterDialog() {
      this.cComponent = "components/coordinator/AddCenterPopup";
      this.alertBoxData = { selectedCenter: this.selectedCenter };
      this.modalwidth = "390px";
      this.status = true;
      this.$forceUpdate();
    },
    AddBatchDialog() {
      this.cComponent = "components/coordinator/AddBatch";
      this.alertBoxData = {
        selectedCenter: this.selectedCenter,
        type: "Add Batch",
      };
      this.modalwidth = "390px";
      this.status = true;
      this.$forceUpdate();
    },
    requestGetBatch(centerId) {
      let reqData = {
        orderBy: this.orderBy,
        center_id: [centerId],
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize > 0 ? this.pageSize : 10,
        },
      };

      this.$root.showLoader = true;
      if (centerId) {
        this.getBatches(reqData)
          .then((response) => {
            if (
              response.list.length == 0 &&
              this.currentPage != 1 &&
              !this.$route.query.resetPage
            ) {
              this.onPageChange(1);
              return;
            }
            this.$root.showLoader = false;
            if (response && response.list && response.list.length) {
              this.batches = response.list;
              this.totalPages = response.pagination.pageCount;
            } else {
              this.batches = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this.getCenters({ orderBy: this.orderByForCenter })
        .then(async (response) => {
          this.$root.showLoader = false;
          this.centers = response;
          if (!this.selectedCenter && this.centers && this.centers.length) {
            // this.selectedCenter = this.centers[0];
            this.checkSessionData();
          }
		  if(!response.length && this.user.role_id === this.roleIds.CO ){
            this.$toasted.error("You do not have a center assigned to you. Please contact your Institute Admin.");
		  }
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getBatchesByCenterId() {
      this.isMobileDevice = this.checkIfMobile();
      this.$nextTick(() => {
        this.setCustomData();
        this.requestGetBatch(this.selectedCenter.id);
      });
    },
    onHeaderAction(e) {},
    onSortChange(e) {
      this.requestGetBatch(this.selectedCenter.id);
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetBatch(this.selectedCenter.id);
    },
  },
  watch: {
    selectedCenter(val) {
      this.addBreadCrumbChilde([
        {
          text: val.name,
          disabled: false,
        },
      ]);
    },
  },
   computed: {
    ...mapState("userStore", ["user"]),
    },
};
</script>
